import { render, staticRenderFns } from "./AppDetailTab3.vue?vue&type=template&id=511dc644&scoped=true";
import script from "./AppDetailTab3.vue?vue&type=script&lang=js";
export * from "./AppDetailTab3.vue?vue&type=script&lang=js";
import style0 from "./AppDetailTab3.vue?vue&type=style&index=0&id=511dc644&prod&lang=less&scoped=true";

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, "511dc644", null);
export default component.exports;